import { render } from "./DropOrdersCardComponent.vue?vue&type=template&id=2e8ef047&scoped=true"
import script from "./DropOrdersCardComponent.vue?vue&type=script&lang=js"
export * from "./DropOrdersCardComponent.vue?vue&type=script&lang=js"

import "./DropOrdersCardComponent.vue?vue&type=style&index=0&id=2e8ef047&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e8ef047"]])

export default __exports__